import { useTranslation } from '@mint-lib/i18n';
import { Add } from '@mint-lib/icons';
import { useIsAllowedPermission } from '@mint-lib/profile-helpers';
import { Button, typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';
import { getRouteApi } from '@mint/routing';

const routeApi = getRouteApi('/_secured/company-profile/flows/');

const PageHeader = () => {
  const { t } = useTranslation('@myn/approval_v2');
  const navigate = routeApi.useNavigate();
  const isReadOnly = !useIsAllowedPermission('approvalFlowFeature:modify');

  const handleCreateFlow = () => {
    navigate({
      to: '/company-profile/flows/new-flow',
    });
  };

  return (
    <div className="flex justify-between gap-4">
      <div>
        <h2 className={cn(typographyVariants({ variant: 'h2' }), 'mb-1')}>
          {t('Approval Flows')}
        </h2>
        <p
          className={typographyVariants({
            variant: 'bodyShort01',
            color: 'secondary',
          })}
        >
          {t('Create and manage approval flows.')}
        </p>
      </div>
      <Button
        aria-label="Create a flow"
        data-dd-action-name="Create new flow"
        size="large"
        variant="contained"
        color="primary"
        onClick={handleCreateFlow}
        disabled={isReadOnly}
      >
        <Add className="shrink-0" />
        {t('New flow')}
      </Button>
    </div>
  );
};

export default PageHeader;
